import React from "react";

const config = {
  unassigned: {
    primary: "Assign in bulk",
    secondary: null,
  },
};

const SelectedActionsPopup = ({
  selectedRowsCount,
  onApproveSelected,
  onRejectSelected,
  onDeselectAll,
  mode,
}) => {
  return (
    <div className="selected-actions-popup">
      <div className="selected-actions-left">
        <span className="selected-count">{selectedRowsCount} selected</span>
        <button className="deselect-button" onClick={onDeselectAll}>
          ✕ Deselect All
        </button>
      </div>
      <div className="selected-actions-right">
        <button
          className="action-button approve-selected"
          style={{ padding: "8px", margin: "0 5px 0 5px" }}
          onClick={onApproveSelected}
        >
          {mode && config[mode] ? config[mode].primary : "Approve Selected"}
        </button>
        {/* <button className="action-button reject-selected" style={{padding:'8px', margin:'0 5px 0 5px'}} onClick={onRejectSelected}>Reject Selected</button> */}
      </div>
    </div>
  );
};

export default SelectedActionsPopup;
